import { render, staticRenderFns } from "./CommaSeparatedSpan.html?vue&type=template&id=8f18d610&"
import script from "./CommaSeparatedSpan.js?vue&type=script&lang=js&"
export * from "./CommaSeparatedSpan.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports